import React from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { formatINR } from "@/lib/api";
import { Reveal } from "@/components/Reveal";
import { useWishlist } from "@/context/WishlistContext";
import { useCart } from "@/context/CartContext";
import { toast } from "sonner";

export const ProductCard = ({ product, index = 0, wide = false }) => {
  const { has, toggle } = useWishlist();
  const { addItem } = useCart();
  const wished = has(product.slug);

  return (
    <Reveal delay={(index % 3) * 0.07} className={wide ? "md:col-span-2" : "md:col-span-1"}>
      <div className="group" data-testid={`product-card-${product.slug}`}>
        <div className={`relative overflow-hidden rounded-3xl bg-[#F5F5F5] zoom-frame card-lift ${wide ? "aspect-[16/10]" : "aspect-[4/5]"}`}>
          <Link to={`/product/${product.slug}`}>
            <img src={`${product.images[0]}?w=1200&q=80`} alt={product.name} loading="lazy" className="w-full h-full object-contain p-4" />
          </Link>
          {product.new_arrival && (
            <span className="absolute top-4 left-4 bg-black text-white text-[10px] uppercase tracking-[0.15em] px-3 py-1.5 rounded-full">New</span>
          )}
          {product.compare_at_price && (
            <span className="absolute top-4 left-4 bg-white text-black text-[10px] uppercase tracking-[0.15em] px-3 py-1.5 rounded-full border border-black/10" style={product.new_arrival ? { top: "3.2rem" } : {}}>Sale</span>
          )}
          <button
            onClick={() => { toggle(product); toast.success(wished ? "Removed from wishlist" : "Added to wishlist"); }}
            data-testid={`wishlist-btn-${product.slug}`}
            aria-label="Wishlist"
            className="absolute top-4 right-4 w-9 h-9 rounded-full bg-white/90 backdrop-blur flex items-center justify-center hover:scale-110 transition-transform"
          >
            <Heart size={16} className={wished ? "fill-black text-black" : "text-black"} />
          </button>
          <button
            onClick={() => { addItem(product, 1); }}
            data-testid={`quick-add-${product.slug}`}
            className="absolute bottom-4 left-1/2 -translate-x-1/2 bg-black text-white rounded-full px-6 py-3 text-[11px] uppercase tracking-[0.15em] opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 transition-all duration-400 whitespace-nowrap"
          >
            Quick add
          </button>
        </div>
        <Link to={`/product/${product.slug}`} className="block mt-4">
          <div className="flex items-baseline justify-between gap-3">
            <h3 className="font-display text-xl tracking-tight">{product.name}</h3>
            <div className="flex items-baseline gap-2 shrink-0">
              {product.compare_at_price && (
                <span className="text-xs text-muted-foreground line-through">{formatINR(product.compare_at_price)}</span>
              )}
              <span className="text-sm">{formatINR(product.price)}</span>
            </div>
          </div>
          <p className="text-xs text-muted-foreground uppercase tracking-[0.12em] mt-1">{product.tagline}</p>
        </Link>
      </div>
    </Reveal>
  );
};
